import Assessment, { IAssessmentSnapshotIn } from "./Assessment";

export const SpiritualAssessmentQuestionsSnapshot = [
  {
    key: "SpiritualDomainTask1",
    timeToComplete: null,
    question:
      `Have you captured the older adult's story where he/she talks about various life experiences, including military service, and shares advice for the future with children, 
      grandchildren, and other members of the family?`,
    answer: "",
    resource: "blank",
    taskName: "Storytelling",
  },
  {
    key: "SpiritualDomainTask2",
    timeToComplete: null,
    question:
      "Have you discussed and documented the older adult's wishes for his/her funeral?",
    answer: "",
    resource: "blank",
    taskName: "Funeral Wishes",
  },
  {
    key: "SpiritualDomainTask3",
    timeToComplete: null,
    question:
      "Have you learned about and discussed end-of-life care with your older adult to understand their preferences?",
    answer: "",
    resource: "blank",
    taskName: "End of Life Care",
  },
  {
    key: "SpiritualDomainTask4",
    timeToComplete: null,
    question:
      "Have you made peace with the older adult in your life?",
    answer: "",
    resource: "blank",
    taskName: "Making Peace",
  },
  {
    key: "SpiritualDomainTask5",
    timeToComplete: null,
    question:
      "It is important to understand the older adult's spiritual beliefs and needs. Have you had this conversation with them?",
    answer: "",
    resource: "blank",
    taskName: "Spiritual Beliefs and Needs",
  },
  {
    key: "SpiritualDomainTask6",
    timeToComplete: null,
    question:
      "Have you learned about faith-based programs for seniors available to the older adult?",
    answer: "",
    resource: "blank",
    taskName: "Faith-Based Programs",
  },
  {
    key: "SpiritualDomainTask7",
    timeToComplete: null,
    question:
      "Have you helped the older adult discover their spiritually inspired, late life purpose for serving others in their church, neighborhood, community, and world?",
    answer: "",
    resource: "blank",
    taskName: "Discovering Purpose",
  },
  {
    key: "SpiritualDomainTask8",
    timeToComplete: null,
    question:
      "Do you pray regularly with and for the older adult?",
    answer: "",
    resource: "blank",
    taskName: "Prayer with Parents",
  },
  {
    key: "SpiritualDomainTask9",
    timeToComplete: null,
    question:
      "Do you know at least one person at their place of worship and how to reach that person in an emergency?",
    answer: "",
    resource: "blank",
    taskName: "Church Contacts",
  },
  // {
  //   key: "SpiritualDomainTask10",
  //   timeToComplete: null,
  //   question:
  //     "Have you engaged in careful financial planning and management of assets to ensure that your parent has sufficient income in retirement or the ability to continue to earn sufficient income to make ends meet?",
  //   answer: "Coming Soon",
  //   resource: "blank",
  //   taskName: "Discovering Purpose",
  // },
  // {
  //   key: "SpiritualDomainTask11",
  //   timeToComplete: null,
  //   question:
  //     "Have you engaged in careful financial planning and management of assets to ensure that your parent has sufficient income in retirement or the ability to continue to earn sufficient income to make ends meet?",
  //   answer: "Coming Soon",
  //   resource: "blank",
  //   taskName: "Widowhood Support",
  // },
  // {
  //   key: "SpiritualDomainTask12",
  //   timeToComplete: null,
  //   question:
  //     "Have you engaged in careful financial planning and management of assets to ensure that your parent has sufficient income in retirement or the ability to continue to earn sufficient income to make ends meet?",
  //   answer: "Coming Soon",
  //   resource: "blank",
  //   taskName: "Healthy Habits",
  // },
];

export const SpiritualAssessmentSnapshot: IAssessmentSnapshotIn = {
  id: "Spiritual",
  questions: SpiritualAssessmentQuestionsSnapshot,
  infoSlideKeys: [
    "SpiritualDomainTask1",
    "SpiritualDomainTask2",
    "SpiritualDomainTask3",
    "SpiritualDomainTask4",
    "SpiritualDomainTask5",
    "SpiritualDomainTask6",
    "SpiritualDomainTask7",
    "SpiritualDomainTask8",
    "SpiritualDomainTask9",
    // "SpiritualDomainTask10",
    // "SpiritualDomainTask11",
    // "SpiritualDomainTask12",
  ],
};

export const DefaultSpiritualAssessment = Assessment.create(
  SpiritualAssessmentSnapshot
);
